import { Svg } from '../common';

interface TopNavigationCareLogoProps {
  color?: string;
  path?: string;
}

export function TopNavigationCareLogo({ color = '#5A2EEA', path = '/', ...props }: TopNavigationCareLogoProps) {
  const InnerComponent = (
    <div className="px-normal-small py-tiny-medium hover:cursor-pointer leading-[0]">
      <Svg src="logo_bznav-care.svg" width={115} height={24} color={color} />
    </div>
  );

  return (
    <a href={path} {...props}>
      {InnerComponent}
    </a>
  );
}
